import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import clsx from 'clsx'
import React from 'react'

import Label from '@/components-latest/primitives/Label'

import Styles from './RadioGroup.module.scss'

const RadioGroupComponent = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={clsx(Styles.radioGroup, className)}
      {...props}
      ref={ref}
    />
  )
})
RadioGroupComponent.displayName = RadioGroupPrimitive.Root.displayName

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={clsx(Styles.radioItem, className)}
      {...props}>
      <RadioGroupPrimitive.Indicator
        forceMount
        className={Styles.radioItemIndicator}
      />
    </RadioGroupPrimitive.Item>
  )
})
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

const RadioGroupRow = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, children, ...props }, ref) => {
  return (
    <Label variant="outline" layout="row" className={className}>
      <RadioGroupItem {...props} ref={ref} />
      {children}
    </Label>
  )
})
RadioGroupRow.displayName = 'RadioGroupLabel'

const RadioGroup = Object.assign(RadioGroupComponent, {
  Item: RadioGroupItem,
  Row: RadioGroupRow
})

export { RadioGroupItem, RadioGroupRow }
export default RadioGroup
